import React, { useState } from "react";
import { sendNotify } from "../../../store/actions/deadlines/table/tableBody";
import { openNotificationWithIcon } from "../../../libs/utils";
import { FormattedMessage } from "react-intl";
import { Checkbox, notification } from "antd";
import TSDialog from "../../general/dialog/index";
import { useDispatch, useSelector } from "react-redux";

const SolicitModal = ({solicitDeadlineId, openSolicitDialog, ragSocCompany, setOpenSolicitDialog}) => {
  const dispatch = useDispatch();
  const [checkbox, setCheckbox] = useState(false);

  const accountantIdSelected = useSelector(state => state.main?.accountantIdSelected);

  // è il cf che viene inviato ma poi lato api serve id. Per molti coincide con il cf ma non sarà sempre cosi
  const sendNotifyToCompany = () => {
    // devo recuperare il vero itemId e non più solo il cf del cliente
    dispatch(sendNotify(solicitDeadlineId));
    openNotificationWithIcon(
      notification,
      "success",
      "",
      "Sollecito inviato correttamente",
      null,
      null,
      5
    );
  };

  const doSolicit = () => {
    let alertNotifyDict =
      localStorage.getItem("alertNotifyDict") !== undefined &&
        localStorage.getItem("alertNotifyDict") !== null
        ? JSON.parse(localStorage.getItem("alertNotifyDict"))
        : {};

    alertNotifyDict[accountantIdSelected] = checkbox;
    setOpenSolicitDialog(false);
    localStorage.setItem("alertNotifyDict", JSON.stringify(alertNotifyDict));
    sendNotifyToCompany();
  };

  const doReset = () => {
    setOpenSolicitDialog(false);
  };
  
  const renderDialogContent = () => {
    return (
      <div>
        <div>
          <FormattedMessage id="deadlines.pages.table.solicitConfirmTitle1" />
          {ragSocCompany}
          <FormattedMessage id="deadlines.pages.table.solicitConfirmTitle2" />
        </div>
        <br />
        <div>
          <Checkbox onChange={() => setCheckbox(!checkbox)} checked={checkbox}>
            <FormattedMessage id="deadlines.pages.table.solicitConfirmHide" />
          </Checkbox>
        </div>
      </div>
    );
  };

  return (
    <TSDialog
      visible={openSolicitDialog}
      title={
        <FormattedMessage id="deadlines.pages.table.solicitDeadline" />
      }
      okText={<FormattedMessage id="actions.confirm" />}
      cancelText={<FormattedMessage id="actions.cancel" />}
      onSubmit={doSolicit}
      onAbort={doReset}
    >
      {renderDialogContent()}
    </TSDialog>
  );
};

export default SolicitModal;